import React from 'react';
import styles from './AssetReportEdit.module.scss';

import { FormProvider, useForm } from 'react-hook-form';

import ReportEditWrapper from '../../commonComponents/ReportEditWrapper';
import AssetReportDetails from './components/GeneralDetails';

export default function AssetReportEdit() {
  const methods = useForm({
    defaultValues: {
      reportType: {},
      asset: {},
      generalReportTemplate: {},
      generalReportFields: [],
      resources: [],
      assignedAtUtc: null,
      signatures: []
    },
    mode: 'onChange'
  });

  return (
    <section className={styles.pageContainer}>
      <FormProvider {...methods}>
        <ReportEditWrapper reportType="asset">
          <AssetReportDetails />
        </ReportEditWrapper>
      </FormProvider>
    </section>
  );
}
